import {
  Backdrop, Container, Input, Paper, Typography, Card, CardContent,
  Divider, CardActions, Button, Grid,
  Dialog, DialogTitle, DialogActions, DialogContent
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser,safeRequestParam } from 'src/utils/Common';
import { getTasksRequest } from '../../store/actions/taskActions';
import Header from 'src/components/Header';
import Fotograf from 'src/views/WorkOrder/Photo';
import Form from 'src/views/File/Form';
import { confirmAlert } from 'react-confirm-alert';
import Alert from '@material-ui/lab/Alert';
import ProductImage from 'src/components/ProductImage/PickArea';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import CropFreeIcon from '@material-ui/icons/CropFree';
import StreetviewIcon from '@material-ui/icons/Streetview';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import BarkodPopup from '../../components/BarcodePopup';
import Alert1 from '@material-ui/lab/Alert';
import SettingsRemoteIcon from '@material-ui/icons/SettingsRemote';
import logger from 'src/utils/logger';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  searchDF: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconDF: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputDF: {
    flexGrow: 1
  },
  searchButtonDF: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  backdropDF: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const trPerspective = {
  "front": "Ön Taraf",
  "back": "Arka Taraf",
  "top": "Üst Taraf",
  "bottom": "Alt Taraf",
  "right": "Sağ Taraf",
  "left": "Sol Taraf"
}


const Dosya = () => {
  const classes = useStyles();
  const [FisNoData, setFisNoData] = useState([]);
  const [Popup, setPopup] = useState(false);
  const [Control, setControl] = useState(0);
  const SessionUser = getUser();
  const [LoadingDF, setLoadingDF] = useState(false);
  const [openBarkod, setOpenBarkod] = useState(false);
  const [ProductImageFisNo, setProductImageFisNo] = React.useState(0);
  const [TopProductImage, setTopProductImage] = React.useState('');
  const [filterFisNoDosya, setfilterFisNoDosya] = useState('462535146');
  const [ProductImageOpen, setProductImageOpen] = React.useState(false);
  const [getDamages, setGetDamages] = React.useState(false);
  const [perspective, setPerspective] = React.useState("");
  const [icDamages, setICDamages] = React.useState([]);

  
  const [Uyari2, setUyari2] = React.useState(false);

  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');



  const [LoadingControl, setLoadingControl] = useState(false);

  const FisNoDetayGetir = () => {
    setLoadingDF(true);
    axios.get('/GetArtemisFisDetay/' + SessionUser.ServiceShopId + '/' + SessionUser.UserId + '/' +safeRequestParam(filterFisNoDosya) || 'a' )
      .then((response) => {
        const Deger = response.data;
        setFisNoData(Deger);
        setLoadingDF(false);
      })
      .catch(error => {
        setLoadingDF(false);
        alert(error.response.data.error);
      });
  };

  const setOpenControl = (param) => {
    if (FisNoData[0]?.FIS_NO === undefined) {
      alert("Fiş numarasından arama yapmanız gerekiyor!...");
      return;
    }

    setControl(param);
    if (param === 2) {
      setOpenBarkod(true);
      return;
    }
    setPopup(true);

  };
  const handleBarkodCloseEvet = async (barkod) => {
    setLoadingDF(true);
    const fisNo = Number(FisNoData[0]?.FIS_NO);

    if (isNaN(fisNo)) {
      alert('Fiş numarası geçersiz');
      return;
    }
    axios.get('/SetArtemisFisBarkodEsle/' + SessionUser.ServiceShopId + '/' + SessionUser.UserId + '/' + fisNo + '/' + barkod?.replaceAll('/', '')).then((response) => {
      setLoadingDF(false);
      alert(response.data);
    }).catch(error => {
      setLoadingDF(false);
            logger.error("Hata detayı:", error.message);
    });
  }
  const handleBarkodClose = async (barkod) => {
    if (barkod.length === undefined) {
      setOpenBarkod(false);
      return;
    }
    setOpenBarkod(false);
    var Uyari = (FisNoData[0]?.FIS_NO || "Bilinmeyen") + " fiş numarasına " + (barkod?.toString() || "") + " barkod eklenecektir. Onaylıyor musunuz?";
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleBarkodCloseEvet(barkod.toString())
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });

  }
  const GetProductImageOpen = () => {
    if (FisNoData[0]?.FIS_NO === undefined) {
      alert("Fiş numarasından arama yapmanız gerekiyor!...");
      return;
    }
    setProductImageFisNo(FisNoData[0]?.FIS_NO);
    setTopProductImage(FisNoData[0]?.TopProductImage);
    setProductImageOpen(true);
  }


  const takeDamages = (takenDamages) => {
    if (!takenDamages || takenDamages.length === 0) {
      setUyariTip("error");
      setUyari2(true);
      setUyariAciklama('Lütfen Hasarlı Bölge Seçiniz');
      setLoadingControl(false);
      setGetDamages(false);
      return;
    }

    // 2. Fiş verisi var mı kontrol et
    const currentFis = FisNoData?.[0];
    if (!currentFis) {
        alert("FisNo, işlem iptal edildi.");
        return;
    }
    
    let productDamages = {
      "WorkOrderId": FisNoData[0]?.FIS_NO?.toString() || "",
      "damages": takenDamages,
      "technicianId": FisNoData[0]?.TEKNISYEN_KODU?.toString() || "",
      "topProduct": FisNoData[0]?.TopProductImage?.toString() || ""
    }
    axios.get(`/DeleteProductDetection/${FisNoData[0]?.FIS_NO}`)
      .then(res => {
        if (res.data.ErrorCode === "0") {
          axios.post('/SetProductDetection', productDamages)
            .then(res => {
              const response = res.data.length === 0 ? [] : res.data;
              setGetDamages(false);
              if (response.ErrorCode === "0") {

                setLoadingControl(false);
                setProductImageOpen(false);
              }
              else {
                setUyariTip("error");
                setUyari2(true);
                setUyariAciklama(response.ErrorCode);
                setLoadingControl(false);
                setGetDamages(false);
                return;
              }
            })
        }
        else {
          setUyariTip("error");
          setUyari2(true);
          setUyariAciklama(res.data.ErrorCode);
          setLoadingControl(false);
          setGetDamages(false);
          return;
        }
      })
  };


  const takePerspective = (takenPerspective) => {
    setPerspective(takenPerspective);
  }

  const handleCloseAway = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari2(false);
  };

  const handleCloseButton = () => {

    setProductImageOpen(false);

  }

  return (
    <Page className={classes.root} title={"Fiş No Dosya Eşleme"}>
      <Container maxWidth="lg">
        <Header />
        {
          LoadingDF ?
            <Backdrop className={classes.backdropDF} open={LoadingDF}>
              <CircularProgress color="inherit" />
            </Backdrop>
            : <div></div>
        }
        <Paper
          className={classes.searchDF}
          elevation={1}>
          <Input
            className={classes.searchInputDF}
            disableUnderline
            onChange={event => { setfilterFisNoDosya(event.target.value) }}
            placeholder="Fiş numarası ile arama yapınız..."
          />
          <Divider orientation="vertical" flexItem />
          <SearchIcon onClick={FisNoDetayGetir} className={classes.searchIconB} />
        </Paper>
      </Container>
      <br />
      <Container>
        <Card>
          <CardContent>
            <Typography variant="h6" component="h2">
              {FisNoData[0]?.FIS_NO || ''} - {FisNoData[0]?.MUSTERI || ''}
              <br />
              {FisNoData[0]?.BASVURU_NEDENI || ''}
              <br />
              {FisNoData[0]?.DURUM || ''}
              <br />
              {FisNoData[0]?.RED_NEDENI || ''}
            </Typography>
          </CardContent>
          <Divider />
          <CardActions>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={() => setOpenControl(1)}
                  endIcon={<FileCopyIcon>Ekle</FileCopyIcon>}
                >
                  {"Dosya Ekle"}
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={() => setOpenControl(2)}
                  endIcon={<CropFreeIcon>Ekle</CropFreeIcon>}
                >
                  Barkod Okut
                </Button>

              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={() => GetProductImageOpen()}
                  endIcon={<StreetviewIcon>Ekle</StreetviewIcon>}
                >
                  Hasar Bölgesi İşaretleme
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={() => setOpenControl(4)}
                  endIcon={<SettingsApplicationsIcon>Ekle</SettingsApplicationsIcon>}
                >
                  Form Gİrİşİ
                </Button>
              </Grid>
            </Grid>
          </CardActions>
        </Card>

      </Container>
      <Dialog
        fullScreen={true}
        open={Popup}
        onClose={() => setPopup(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          İşlemler
        </DialogTitle>
        <Divider />
        <DialogContent>
          {Control === 1
            ? <Fotograf FisNo={FisNoData[0]?.FIS_NO} readonly={false} />
            : Control === 4
              ? <Form FisNo={FisNoData[0]?.FIS_NO} readonly={false} BasvuruNedeni={FisNoData[0]?.BASVURU_NEDENI} />
              : ""
          }
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={() => setPopup(false)}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      <BarkodPopup
        onClose={handleBarkodClose}
        open={openBarkod}
        ScanTime={0}
        CallScreen={0}
      />

      <Dialog
        open={ProductImageOpen}
        onClose={() => setProductImageOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen>
        <DialogTitle id="alert-dialog-title">
          Hasar Bölgesi İşaretleme
          <Divider />
        </DialogTitle>
        <DialogContent>
          <Typography align={"center"}>{`Mevcut Görünüm: ${trPerspective[perspective]}`}</Typography>
          <ProductImage takeDamages={takeDamages} getDamages={getDamages} takePerspective={takePerspective} setProductDamages={setICDamages} Product={TopProductImage} FisNo={ProductImageFisNo} />
          <Typography align={"center"}>{`${icDamages.length} adet hasar seçtiniz.`}</Typography>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Alert1 severity="warning">{"*Görseller semboliktir."}</Alert1>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  setLoadingControl(true);
                  setGetDamages(true);
                }
                }
                className={classes.submitButtonWudaq}
                endIcon={<SettingsRemoteIcon>Getir</SettingsRemoteIcon>}
              >
                Gönder
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleCloseButton()}
                className={classes.submitButtonWudaq}
                endIcon={<CloseIcon>Close</CloseIcon>}
              >
                Kapat
              </Button>
            </Grid>
          </Grid>
          {
            LoadingControl ?
              <Backdrop className={classes.backdrop} open={LoadingControl}>
                <CircularProgress color="inherit" />
              </Backdrop>
              : ""
          }
        </DialogActions>
        {
          Uyari2 ?
            <Alert onClose={handleCloseAway} message={uyariAciklama} variant={uyariTip} />
            : <div></div>
        }
      </Dialog>




    </Page>
  );
}


export default connect(
  state => ({ tasks: state.tasks1 })
  ,
  {
    getTasksRequest
  }
)(Dosya);
